import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FaGavel } from 'react-icons/fa';

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      title: '1. Reservas y Pagos',
      points: [
        'Para confirmar una reserva, se requiere el pago por adelantado del 50% del total de la estadía.',
        'El 50% restante deberá ser abonado al momento de su llegada (check-in).',
        'Aceptamos pagos mediante transferencia bancaria, Yape, Plin y tarjetas de crédito/débito (se aplica un recargo del 5% para pagos con tarjeta).',
        'La reserva no se considerará confirmada hasta que el pago inicial haya sido recibido y verificado por nuestro equipo.',
      ],
    },
    {
      title: '2. Horarios de Check-in y Check-out',
      points: [
        '<strong>Check-in (Hora de Ingreso):</strong> A partir de las 07:00 AM. Si planea llegar en un horario diferente, le agradecemos nos contacte para coordinar.',
        '<strong>Check-out (Hora de Salida):</strong> Para estancias de una noche, el check-out es a más tardar a las 12:00 PM (mediodía).',
        'Para estancias de más de una noche, el check-out es a más tardar a las 11:00 AM.',
      ],
    },
    {
      title: '3. Política de Cancelaciones y Modificaciones',
      points: [
        'Entendemos que los planes pueden cambiar. Si necesita modificar o cancelar su reserva, debe contactarnos directamente a nuestro correo electrónico o número de WhatsApp con la mayor antelación posible.',
        'Las solicitudes de cancelación o modificación serán evaluadas caso por caso para ofrecer una solución personalizada y justa.',
      ],
    },
    {
      title: '4. Comportamiento y Responsabilidad del Huésped',
      points: [
        'Agradecemos a nuestros huéspedes mantener un comportamiento respetuoso con el resto de los visitantes, el personal y las instalaciones del hotel.',
        'Se debe respetar el horario de silencio y descanso nocturno, establecido de 10:00 PM a 08:00 AM.',
        'El huésped titular de la reserva es responsable por cualquier daño o perjuicio causado a la propiedad del hotel, ya sea por sí mismo o por sus acompañantes.',
      ],
    },
    {
      title: '5. Niños y Huéspedes Adicionales',
      points: [
        'Los niños menores de 5 años que compartan cama con sus padres no tienen costo adicional.',
        'La capacidad máxima de cada habitación debe ser respetada por seguridad y comodidad. Por favor, consulte antes de traer huéspedes adicionales no registrados en la reserva.',
      ],
    },
    {
      title: '6. Mascotas',
      points: [
        'Aunque amamos a los animales, actualmente nuestras instalaciones no están preparadas para recibir mascotas. Agradecemos su comprensión.',
      ],
    },
    {
      title: '7. Limitación de Responsabilidad',
      points: [
        'Sumaq Mayu no se hace responsable por la pérdida, robo o daño de objetos de valor, dinero u otros efectos personales de los huéspedes durante su estadía.',
        'Recomendamos a nuestros huéspedes mantener sus objetos de valor en un lugar seguro y no dejarlos desatendidos en áreas comunes.',
      ],
    },
    {
      title: '8. Privacidad de Datos',
      points: [
        'Los datos personales proporcionados durante el proceso de reserva serán tratados con estricta confidencialidad y utilizados únicamente con el fin de gestionar su estadía y comunicarnos con usted, conforme a las leyes de protección de datos.',
      ],
    },
  ];

  return (
    <div className="bg-gray-50">
      <Navbar />
      
      <header 
        className="relative bg-cover bg-center pt-40 pb-24" 
        style={{ backgroundImage: `url(/images/cta-bg.jpg)` }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative container mx-auto px-4 text-center text-white">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl sm:text-5xl md:text-6xl font-playfair font-bold"
          >
            Términos y Condiciones
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-4 text-lg max-w-3xl mx-auto"
          >
            Al realizar una reserva en Sumaq Mayu, usted acepta y se compromete a cumplir con las siguientes políticas, diseñadas para asegurar una experiencia segura, justa y memorable para todos nuestros huéspedes.
          </motion.p>
        </div>
      </header>

      <main className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl">
          <div className="bg-white p-8 sm:p-12 rounded-2xl shadow-xl">
            {sections.map((section, index) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="mb-10 pb-10 border-b border-gray-200 last:border-b-0 last:mb-0 last:pb-0"
              >
                <h2 className="flex items-center text-2xl lg:text-3xl font-playfair font-semibold text-gray-800 mb-6">
                  <FaGavel className="mr-4 text-green-700" />
                  {section.title}
                </h2>
                <ul className="space-y-4 pl-6">
                  {section.points.map((point, i) => (
                     <li key={i} className="relative pl-6 text-base lg:text-lg text-gray-700 leading-relaxed">
                       <span className="absolute left-0 top-1.5 h-2 w-2 bg-green-600 rounded-full" />
                       <span dangerouslySetInnerHTML={{ __html: point }} />
                     </li>
                  ))}
                </ul>
              </motion.div>
            ))}
             <p className="mt-12 text-center text-sm text-gray-500">
              Sumaq Mayu se reserva el derecho de actualizar estos términos y condiciones en cualquier momento para reflejar cambios en nuestras operaciones o regulaciones.
              <br/>
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;